// same regex used by jsdiff
// https://github.com/kpdecker/jsdiff/blob/v6.0.0/src/diff/word.js#L22
const wordSeparator = new RegExp(
  '[^a-zA-Z0-9_\\u{C0}-\\u{FF}\\u{D8}-\\u{F6}\\u{F8}-\\u{2C6}\\u{2C8}-\\u{2D7}\\u{2DE}-\\u{2FF}\\u{1E00}-\\u{1EFF}]+',
  'ug',
);

export function getWordCount(text: string) {
  const words = text
    .split(wordSeparator)
    .filter((word, index, array) => !!word || array[index - 1] !== word);
  return words.length;
}
